import * as configSelectors from './selectors';

export const selectors = configSelectors;
export * from './actions';
export { default as reducer } from './reducer';
